import { getDefaultPage } from 'app-webtech-core/store/routes';
import { subselect } from './root';

const pageSelector = ({ routesMap, type, payload = {} }) => {
  const route = routesMap[type];

  let page;
  if (route) {
    ({ page } = route);

    if (!page) {
      ({ page } = payload);
    }
  }

  if (!page) {
    page = getDefaultPage(routesMap);
  }

  return page;
};

export const locationPageSelector = subselect(pageSelector);
